var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lazy)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src),expression:"src"}],class:_vm.classes,attrs:{"alt":_vm.alt}}):_c('img',{class:_vm.classes,attrs:{"src":_vm.src,"alt":_vm.alt}})
}
var staticRenderFns = []

export { render, staticRenderFns }